import {createUseMutation, createUseQuery} from "@irati/utils/services/apollo"
import {
  CustomReward,
  MutationCreateCustomRewardArgs,
  MutationUpdateCustomRewardArgs,
  MutationUpdateCustomRewardStatusArgs,
  QueryCustomRewardArgs,
  QueryCustomRewardsArgs,
  CustomRewardTransaction,
  QueryCustomRewardsTransactionsArgs,
  MutationRedeemCustomRewardArgs
} from "@irati/types"
import createCustomRewardMutation from "../apollo/mutation/CreateCustomReward"
import updateCustomRewardStatusMutation from "../apollo/mutation/UpdateCustomRewardStatus"
import updateCustomRewardMutation from "../apollo/mutation/UpdateCustomReward"
import redeemCustomRewardMutation from "../apollo/mutation/RedeemCustomReward"
import getCustomRewardsQuery, {getCustomRewardsQueryKey} from "../apollo/query/CustomRewards"
import getCustomRewardQuery, {getCustomRewardQueryKey} from "../apollo/query/CustomReward"
import getCustomRewardsTransactionsQuery, {getCustomRewardsTransactionsQueryKey} from "../apollo/query/CustomRewardsTransactions"
import getMyCustomRewardsTransactionsQuery, {getMyCustomRewardsTransactionsQueryKey} from "../apollo/query/MyCustomRewardsTransactions"
import getCountAvailableCustomRewardsQuery, {getCountAvailableCustomRewardsQueryKey} from "../apollo/query/CountAvailableCustomRewards"

const customRewardErrorCodeMap: Record<string, string> = {}

export default function customRewardErrorHandlers(code: string) {
  return customRewardErrorCodeMap[code] ?? ""
}
export const useCreateCustomRewardMutation = createUseMutation<CustomReward, MutationCreateCustomRewardArgs>(createCustomRewardMutation, {
  key: "createCustomReward",
  errorHandlers: [customRewardErrorHandlers]
})
export const useUpdateCustomRewardMutation = createUseMutation<CustomReward, MutationUpdateCustomRewardArgs>(updateCustomRewardMutation, {
  key: "updateCustomReward",
  errorHandlers: [customRewardErrorHandlers]
})
export const useUpdateCustomRewardStatusMutation = createUseMutation<CustomReward, MutationUpdateCustomRewardStatusArgs>(
  updateCustomRewardStatusMutation,
  {
    key: "updateCustomRewardStatus",
    errorHandlers: [customRewardErrorHandlers]
  }
)
export const useCustomRewardsQuery = createUseQuery<CustomReward[], QueryCustomRewardsArgs>(getCustomRewardsQuery, {
  key: getCustomRewardsQueryKey
})
export const useCustomRewardQuery = createUseQuery<CustomReward, QueryCustomRewardArgs>(getCustomRewardQuery, {
  key: getCustomRewardQueryKey
})
export const useListCustomRewardsTransactionsQuery = createUseQuery<CustomRewardTransaction[], QueryCustomRewardsTransactionsArgs>(
  getCustomRewardsTransactionsQuery,
  {
    key: getCustomRewardsTransactionsQueryKey
  }
)
export const useMyListCustomRewardsTransactionsQuery = createUseQuery<CustomRewardTransaction[]>(getMyCustomRewardsTransactionsQuery, {
  key: getMyCustomRewardsTransactionsQueryKey
})
export const useCountAvailableCustomRewardsQuery = createUseQuery<number>(getCountAvailableCustomRewardsQuery, {
  key: getCountAvailableCustomRewardsQueryKey
})
export const useRedeemCustomRewardMutation = createUseMutation<CustomReward, MutationRedeemCustomRewardArgs>(redeemCustomRewardMutation, {
  key: "redeemCustomReward",
  errorHandlers: [customRewardErrorHandlers]
})
